import { render, staticRenderFns } from "./SModal.vue?vue&type=template&id=63065bc2&scoped=true&lang=pug"
import script from "./SModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SModal.vue?vue&type=style&index=0&id=63065bc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63065bc2",
  null
  
)

export default component.exports